import { useParams } from 'react-router';
import { useActualFormToken } from './useActualFormToken';

export const useSourceDatasetConditions = () => {
  const { field, subsetId } = useParams<{
    field?: string;
    subsetId?: string;
  }>();
  const actualToken = useActualFormToken();

  const displayReferenceDataset =
    actualToken?.parentTokenId !== null && field !== undefined;

  const displaySlaveDataset = subsetId !== undefined;

  return {
    displayReferenceDataset,
    displaySlaveDataset,
  };
};
